module.exports = __webpack_public_path__ + "static/media/icons8-account.dfd2feb7.svg";